module.exports = __webpack_public_path__ + "static/img/200177.93cd08a5.png";